import dantePic from "@/public/images/artists/dante.png";
import { Artist } from "@/types/types";

export const dante = {
  id: "193",
  name: "Dante",
  image: dantePic,
  description: `Dante's voice sits in a naturally androgynous space, with a light yet resonant timbre that can lean either way depending on phrasing and tonal placement. The lower register is warm and slightly husky, offering a soft yet present depth, while the upper register remains bright, clear, and effortlessly controlled.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fdante-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["RnB", "Soundtrack", "Ballads", "Unprocessed", "Falsetto"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 50,
        high: 72,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
